import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputProps, NotesV2 } from '../../UI';
import { TaxReturnSummaryFormValues } from '../types';

type TaxReturnSummaryNotesTextAreaProps = Pick<InputProps, 'className'>;

export const TaxReturnSummaryNotesTextArea: FC<TaxReturnSummaryNotesTextAreaProps> = ({ className }) => {
  const { t: tCommon } = useTranslation('common');
  const { control } = useFormContext<TaxReturnSummaryFormValues>();
  const { field, fieldState } = useController<TaxReturnSummaryFormValues, 'notes'>({
    control,
    name: 'notes',
  });

  return (
    <NotesV2
      {...field}
      className={className}
      label={tCommon('notes')}
      defaultValue={field.value}
      status={fieldState.error ? 'errored' : 'normal'}
    />
  );
};
